module.exports = __webpack_public_path__ + "img/sv79.1d1a5e9b.svg";